var ItamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfig } from "../../models/module-config.model";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { AppControllerService } from "../../../app-controller.service";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { ODataAction } from "../odata-query/odata-action.model";
import { AlertType } from "../../models/alert";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { SharedConstants } from "../../constants/shared.constants";
import { map } from "rxjs/operators";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { CreateApplicationDetailsItamsComponent } from "../../../create-application/modules/it/create-application-details-itams/create-application-details-itams.component";
import { CreateApplicationLocationItamsComponent } from "../../../create-application/modules/it/create-application-location-itams/create-application-location-itams.component";
import { CreateApplicationStakeholdersItamsComponent } from "../../../create-application/modules/it/create-application-stakeholders-itams/create-application-stakeholders-itams.component";
import { ViewApplicationDetailsItamsComponent } from "../../../view-application/modules/it/view-application-details-itams/view-application-details-itams.component";
import { ViewApplicationLocationItamsComponent } from "../../../view-application/modules/it/view-application-location-itams/view-application-location-itams.component";
import { ViewApplicationStakeholdersItamsComponent } from "../../../view-application/modules/it/view-application-stakeholders-itams/view-application-stakeholders-itams.component";
import { ApiInformalTradeConstants } from "../../constants/api-constants/api-informal-trade.constants";
import { CreateApplicationLocationItamsConstants } from "../../../create-application/modules/it/create-application-location-itams/create-application-location-itams.constants";
import { ViewApplicationDocumentationComponent } from "../../../view-application/view-application-documentation/view-application-documentation.component";
import { CreateApplicationDocumentationComponent } from "../../../create-application/create-application-documentation/create-application-documentation.component";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.Agent, "agent"], [ApplicationHeadingEnum.ErfNumber, "erfNumbers"], [ApplicationHeadingEnum.ApplicationType, "type"], [ApplicationHeadingEnum.CreatedDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([[ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"], [ApplicationSummaryColumnsEnum.Applicant, "applicant"], [ApplicationSummaryColumnsEnum.Agent, "agent"], [ApplicationSummaryColumnsEnum.ApplicationType, "type"], [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"], [ApplicationSummaryColumnsEnum.Phase, "phase"], [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"], [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"], [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"]]);
export const ItExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_IT;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationMenuHeadings["Location"] = "Bay details";
    CreateApplicationMenuHeadings["Details"] = "Application details";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Agent"] = "Agent";
    CreateApplicationMenuHeadings["Traders"] = "Traders";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
    CreateApplicationMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Bays help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["Traders"] = "Traders help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationMenuHeadings.Traders, HeaderConfigurableTextTypes.Traders)
    .set(CreateApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Bay details";
    ViewApplicationMenuHeadings["Details"] = "Application details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["Traders"] = "Traders";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.Traders, HeaderConfigurableTextTypes.Traders)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let ItamsStrategyService = class ItamsStrategyService extends AflaModuleStrategyService {
    static { ItamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.InformalTrade;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiInformalTradeConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = ItExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiInformalTradeConstants.URL}/${ApiInformalTradeConstants.FUNCTION_GET_MY_AFLA_INFORMAL_TRADING_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, ItExpandListForApplicationSearch);
    }
    buildListFilter(list, column) {
        const params = ItamsStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: ItamsStrategyService_1.getRecipientName(ItamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: ItamsStrategyService_1.getRecipientName(ItamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            type: application.type,
            startDate: this.saShortDatePipe.transform(application.createdDate),
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([[ViewApplicationMenuHeadings.Details, ViewApplicationDetailsItamsComponent], [ViewApplicationMenuHeadings.Location, ViewApplicationLocationItamsComponent], [ViewApplicationMenuHeadings.Traders, ViewApplicationStakeholdersItamsComponent], [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent], [ViewApplicationMenuHeadings.Documentation, ViewApplicationDocumentationComponent]]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([[CreateApplicationMenuHeadings.Details, CreateApplicationDetailsItamsComponent], [CreateApplicationMenuHeadings.Location, CreateApplicationLocationItamsComponent], [CreateApplicationMenuHeadings.Traders, CreateApplicationStakeholdersItamsComponent], [CreateApplicationMenuHeadings.Notes, CreateApplicationNotesComponent], [CreateApplicationMenuHeadings.Documentation, CreateApplicationDocumentationComponent]]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiInformalTradeConstants.URL}/${ApiInformalTradeConstants.FUNCTION_GET_ALL_AFLA_PORTAL_INFORMAL_TRADING_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = ItamsStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, ItamsStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(ItamsStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                this.resetForm();
                this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
            }, error: (error) => {
                this.appController.handleServerErrorMessage("create informal trade application", error, CRUDOperation.Add);
            }
        });
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Traders.toLocaleLowerCase():
                application = this.buildStakeholderStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                itApplication: application, moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest bays
                    const params = {
                        $select: "bays,tradeGoods,notes",
                        $expand: "bays,tradeGoods,notes",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            const bays = response.value[0]?.bays;
                            const tradeGoods = response.value[0]?.tradeGoods;
                            savedApplication.bays = bays;
                            savedApplication.tradeGoods = tradeGoods;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(ItamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FEEL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.itApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(ItamsStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiInformalTradeConstants.URL}/${applicationId}/${ApiInformalTradeConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiInformalTradeConstants.URL}/${applicationId}/${ApiInformalTradeConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                formName = "baysForm";
                break;
            case CreateApplicationMenuHeadings.Traders.toLocaleLowerCase():
                formName = "tradersForm";
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetForm() {
        this.form.reset();
        this.form.get("baysForm").get("bays").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiInformalTradeConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, applicationTypes, bays, traders($expand=groups), lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TP_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiInformalTradeConstants.URL}/${jobId}/${ApiInformalTradeConstants.FUNCTION_GET_APPLICATION_TYPE}`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("baysForm") && this.form.get("baysForm").get("bays")) {
            const baysArray = this.form.get("baysForm").get("bays");
            if (baysArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage(CreateApplicationLocationItamsConstants.BAY_REQUIRED, AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage(CreateApplicationLocationItamsConstants.BAY_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    resetFormForStep(step) {
        const previousApplicationValidated = this.form.get("detailsForm").get("previousApplicationValidated").value;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("baysForm").get("bays").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                if (!previousApplicationValidated) {
                    this.form.get("detailsForm").get("description").reset();
                    this.form.get("detailsForm").get("type").reset();
                    this.form.get("detailsForm").get("tradeGoods").reset();
                    this.form.get("detailsForm").get("previousReferenceNumber").reset();
                    this.applicationCreateService.$clearApplicationVerificationSubject.next(true);
                }
                else {
                    this.appController.showMessage("Form cannot be cleared after previous application has been validated", AlertType.Warning);
                }
                break;
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Traders.toLocaleLowerCase():
                if (!previousApplicationValidated) {
                    this.form.get("tradersForm").get("traders").reset();
                }
                else {
                    this.appController.showMessage("Form cannot be cleared after previous application has been validated", AlertType.Warning);
                }
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    buildLocationStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.bays = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                bays: [],
                shape: "",
                wkid: 102100
            };
        const points = [];
        const baysArray = this.form
            .get("baysForm")
            .get("bays");
        baysArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const bay = {
                id: item.get("id").value,
                address: item.get("address").value,
                bayNumber: item.get("bayNumber").value,
                baySize: item.get("baySize").value,
                shape: geometryJSON,
                updateGeometry: false,
                wkid: 102100
            };
            application.bays.push(bay);
        });
        application.shape = `MULTIPOINT (${points.join(", ")})`;
        return application;
    }
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        const tradeGoodsFormArray = this.form.get("detailsForm").get("tradeGoods");
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.description = this.form.get("detailsForm").get("description").value;
            application.type = this.form.get("detailsForm").get("type").value;
            application.previousReferenceNumber = this.form.get("detailsForm").get("previousReferenceNumber").value;
            application.tradeGoods = [];
        }
        else {
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
                description: this.form.get("detailsForm").get("description").value,
                type: this.form.get("detailsForm").get("type").value,
                tradingGoods: this.form.get("detailsForm").get("tradingGoods").value,
                tradingGoodsDescription: this.form.get("detailsForm").get("tradingGoodsDescription").value,
                previousReferenceNumber: this.form.get("detailsForm").get("previousReferenceNumber").value,
                tradeGoods: []
            };
        }
        tradeGoodsFormArray.controls.forEach((tradeGoodsControl) => {
            const tradeGoods = {
                id: tradeGoodsControl.get("id") !== null ? tradeGoodsControl.get("id").value : 0,
                tradeGoods: tradeGoodsControl.get("tradeGoods").value,
                description: tradeGoodsControl.get("tradingGoodsDescription").value,
            };
            application.tradeGoods.push(tradeGoods);
        });
        return application;
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: "",
            type: "",
            tradingGoods: "",
            tradingGoodsDescription: "",
            previousReferenceNumber: "",
            traders: [],
            tradeGoods: [],
            shape: "",
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            bays: [],
            eLodgementStep: 0,
            eLodgementComplete: true,
        };
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        if (existingApplication) {
            existingApplication.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            existingApplication.applicantAgentNa = applicantAgentIsNullValue;
            existingApplication.eLodgementStep = stepIndex;
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else {
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        }
        return application;
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null),
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                type: new FormControl(null),
                tradeGoods: new FormArray([new FormGroup({
                        tradeGoods: new FormControl(null, [Validators.required]),
                        tradingGoodsDescription: new FormControl({ value: null, disabled: true })
                    })], [minLengthArray(1), Validators.required]),
                previousApplicationValidated: new FormControl(false),
                previousReferenceNumber: new FormControl(null),
                referenceNumber: new FormControl(null),
            }),
            tradersForm: new FormGroup({
                traders: new FormControl({ recipients: [] }, Validators.required),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            baysForm: new FormGroup({
                bays: new FormArray([], [minLengthArray(1), Validators.required]),
            }),
        });
    }
    buildStakeholderStep(stepIndex, existingApplication) {
        const traders = this.form.get("tradersForm")?.get("traders").value;
        traders.forEach((trader) => {
            RecipientUtils.removeInvalidRecipientProperties(trader);
        });
        if (existingApplication) {
            existingApplication.traders = traders;
            existingApplication.eLodgementStep = stepIndex;
        }
        return existingApplication;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
ItamsStrategyService = ItamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsubPortal()
], ItamsStrategyService);
export { ItamsStrategyService };
